module.exports = __webpack_public_path__ + "img/IMG-20200919-WA0073.4a975973.jpg";